<div
  class="new-gradient"
  style="width: 100%; height: 100vh; overflow: hidden"
  *ngIf="!isDownload && !folderId"
>
  <div class="h-100 row align-items-center justify-content-center">
    <div class="col-10 resource-box text-center">
      <div *ngIf="isAuthorize" [ngSwitch]="resourceType">
        <div *ngSwitchCase="1">
          <img
            class="mw-100 mh-100"
            [src]="getAssets() | loadSecureAssets : true | async"
            onerror="this.src = 'assets/img/loader.gif'"
            (load)="imageLoaded = true"
            [hidden]="!imageLoaded"
          />
        </div>
        <div *ngSwitchCase="2">
          <app-vplaybook-video-viewer
            [videoClass]="videoClass"
            [setIsPlaying]="false"
            [videoAssetId]="assetId"
            [setVideoSrc]="getAssets()"
          >
          </app-vplaybook-video-viewer>
        </div>
        <div *ngSwitchCase="3">
          <embed
            class="mw-100 mh-100"
            style="width: 100%; height: 400px"
            type="application/pdf"
            [src]="
              getAssets()
                | loadSecureAssets : true
                | async
                | safe : 'resourceUrl'
            "
          />
        </div>
      </div>
      <div *ngIf="!isAuthorize" class="text-white">
        <p>YOU ARE NOT AUTHORIZED TO ACCESS THE DATA</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isDownload">
  <div class="gradient-bg">
    <p class="detail-text">
      Resource is downloading now. If not
      <button
        class="btn btn__btn-default btn__orange letter-spacing"
        (click)="downloadAsset(resource)"
      >
        click here
      </button>
      to download.
    </p>
  </div>
  <img class="image" src="/assets/img/resource-landing.png" />
</div>
<span *ngIf="!isOffline"> </span>
<div *ngIf="folderId">
  <div class="social_page_wrapper">
    <div class="col-md-10 offset-md-1 text-center text-white pt-3">
      <h4>
        Click the resource you'd like to download, email, rate/leave feedback
        on, or copy the URL for, below.
      </h4>
    </div>
    <div class="social_page_inner">
      <div class="social_page_scrollbar">
        <div
          class="social_page_grid"
          *ngFor="let folderResource of folderResources"
          id="resource-{{ folderResource.id }}"
        >
          <div [ngSwitch]="folderResource.type">
            <h4>
              <a
                class="resource-list-title pointer"
                (click)="openResourceUrl(folderResource)"
                target="blank"
                *ngSwitchCase="1"
                [hidden]="isOffline"
              >
                {{ folderResource.title }}
              </a>
              <a
                class="resource-list-title pointer"
                *ngSwitchCase="1"
                (click)="openResourceUrl(folderResource)"
                [hidden]="!isOffline"
              >
                {{ folderResource.title }}
              </a>
              <a
                class="resource-list-title pointer"
                [routerLink]="'/home/resourcelanding'"
                [queryParams]="{
                  resourceId: folderResource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                }"
                target="blank"
                *ngSwitchCase="2"
              >
                {{ folderResource.title }}
              </a>
              <a
                id="resourcesListId"
                class="resource-list-title pointer"
                [routerLink]="'/home/resourcelanding'"
                [queryParams]="{
                  resourceId: folderResource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                }"
                target="blank"
                [ngClass]="{
                  'not-active-link': !checkResourceForNullAssets(folderResource)
                }"
                *ngSwitchDefault
                >{{ folderResource.title }}</a
              >
            </h4>
          </div>
          <ul>
            <a
              *ngIf="
                folderResource.type != 1 &&
                checkResourceAssetCondition(folderResource)
              "
              target="_blank"
              [href]="openResource(folderResource)"
              placement="bottom"
              container="body"
              tooltip="Download"
            >
              <span><i class="material-icons">cloud_download</i></span>
            </a>
            <a
              *ngIf="
                !pageTemplateId &&
                languageId === defaultLanguageId &&
                checkResourceAssetCondition(folderResource)
              "
              placement="bottom"
              container="body"
              tooltip="Email Resource"
              (click)="openMailResourceModal(folderResource)"
            >
              <span><i class="material-icons">mail_outline</i></span>
            </a>

            <a
              placement="bottom"
              container="body"
              tooltip="Rate Resource"
              (click)="openRatingsModal(folderResource.id)"
              *ngIf="
                !pageTemplateId &&
                languageId === defaultLanguageId &&
                languageId === defaultLanguageId
              "
              [hidden]="pageFrom"
            >
              <span><i class="material-icons">star_border</i></span>
            </a>
            <a
              placement="bottom"
              container="body"
              tooltip="Copy Resource Shareable Link"
              (click)="
                copyResourceShareableLink({
                  resourceId: folderResource.id,
                  languageId: languageId,
                  pageTemplateId: pageTemplateId,
                  pageFrom: pageFrom
                })
              "
              *ngIf="
                folderResource.type != 1 &&
                checkResourceForNullAssets(folderResource)
              "
            >
              <span><i class="material-icons">link</i></span>
            </a>
          </ul>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          type="button"
          class="btn btn__btn-default btn__orange download__btn"
          *ngIf="isResource"
          (click)="downloadFolder(folderId)"
        >
          download all <span class="material-icons">file_download</span>
        </button>
      </div>
    </div>
  </div>
</div>

<a
  *ngIf="!!getBackUrl()"
  [href]="getBackUrl()"
  class="close-btn"
  placement="bottom"
  container="body"
  tooltip="Back"
  ><span
    ><i _ngcontent-xbc-c7="" class="material-icons" data-bs-dismiss="modal"
      >close</i
    ></span
  ></a
>
